/** Big card in the „KI“ menu: the main pitch, own AI runs the whole software without login. */
import { ArrowRight } from "lucide-react";
import { useTranslations } from "next-intl";
import Link from "next/link";
import type { ReactNode } from "react";

import { AI_MENU_FEATURE_HREF, AI_MENU_FEATURE_LOGOS } from "./product-menu-items";

export function AiMenuFeature(props: { readonly onNavigate: () => void }): ReactNode {
  const t = useTranslations("marketing.productMenu");
  return (
    <Link
      href={AI_MENU_FEATURE_HREF}
      className="mkpm-feature"
      onClick={props.onNavigate}
    >
      <span className="mkpm-feature-logos">
        {AI_MENU_FEATURE_LOGOS.map((logo) => (
          <span key={logo.name} className="mkpm-feature-logo">
            {/* eslint-disable-next-line @next/next/no-img-element -- tiny static brand mark */}
            <img
              src={logo.src}
              alt={logo.name}
              width={20}
              height={20}
              className={logo.mono ? "mk-logo-mono" : undefined}
              draggable={false}
            />
          </span>
        ))}
      </span>
      <span className="mkpm-feature-title">{t("kiFeatureTitel")}</span>
      <span className="mkpm-feature-text">{t("kiFeatureText")}</span>
      <span className="mkpm-feature-cta">
        {t("kiFeatureCta")}
        <ArrowRight size={15} strokeWidth={2} aria-hidden="true" />
      </span>
    </Link>
  );
}
